module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [(_vm.$wxOpenId) ? _c('el-row', {
    staticClass: "header"
  }, [_c('Navi'), _vm._v(" "), _c('div', {
    staticClass: "userinfo"
  }, [_c('el-popover', {
    attrs: {
      "placement": "right",
      "width": "424",
      "trigger": "click",
      "popper-class": "popover-db"
    },
    model: {
      value: (_vm.popover),
      callback: function($$v) {
        _vm.popover = $$v
      },
      expression: "popover"
    }
  }, [_c('div', {
    staticClass: "db-top"
  }, [_c('span', {
    class: _vm.msgType == 1 ? 'current' : '',
    on: {
      "click": function($event) {
        return _vm.toMsg(1)
      }
    }
  }, [_vm._v("我的待办"), (_vm.messageCount) ? _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("(" + _vm._s(_vm.messageCount) + ")")]) : _vm._e()]), _vm._v(" "), _c('span', {
    class: _vm.msgType == 2 ? 'current' : '',
    on: {
      "click": function($event) {
        return _vm.toMsg(2)
      }
    }
  }, [_vm._v("抄送我"), (_vm.messageCount2) ? _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("(" + _vm._s(_vm.messageCount2) + ")")]) : _vm._e()]), _vm._v(" "), _c('i', {
    staticClass: "el-icon-close",
    staticStyle: {
      "float": "right",
      "margin-top": "14px",
      "font-size": "21px",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.popover = false
      }
    }
  })]), _vm._v(" "), (_vm.msgType == 1) ? _c('div', [(_vm.msgList.length) ? _c('ul', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.load),
      expression: "load"
    }, {
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "msg",
    staticClass: "infinite-list"
  }, [_vm._l((_vm.msgList), function(item) {
    return _c('li', {
      staticClass: "infinite-list-item",
      on: {
        "click": function($event) {
          return _vm.$root.gotoDetail(item)
        }
      }
    }, [_c('div', {
      staticClass: "ft"
    }, [_vm._v(_vm._s(item.initiatorName) + "提交的" + _vm._s(item.itemName))]), _vm._v(" "), _c('div', {
      staticClass: "ov"
    }, [_vm._v(_vm._s(item.bizItemName))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$root.formatDate(item.initiateTime)))])])
  }), _vm._v(" "), (_vm.pageCount == _vm.pageNo && _vm.msgList.length > 6) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("下面没有数据啦")]) : _vm._e()], 2) : _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("暂无消息")])]) : _vm._e(), _vm._v(" "), (_vm.msgType == 2) ? _c('div', [_c('el-checkbox', {
    staticStyle: {
      "padding-top": "12px"
    },
    attrs: {
      "true-label": "Y",
      "false-label": ""
    },
    on: {
      "change": _vm.awaitChange
    },
    model: {
      value: (_vm.isAwait),
      callback: function($$v) {
        _vm.isAwait = $$v
      },
      expression: "isAwait"
    }
  }, [_vm._v("未读抄送")]), _vm._v(" "), (_vm.msgList2.length) ? _c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.load2),
      expression: "load2"
    }, {
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "msg2",
    staticClass: "infinite-list"
  }, [_vm._l((_vm.msgList2), function(item) {
    return _c('div', {
      staticClass: "infinite-list-item copy",
      class: item.isAwait == 'Y' ? 'unread' : '',
      on: {
        "click": function($event) {
          return _vm.$root.gotoDetail(item)
        }
      }
    }, [_c('div', {
      staticClass: "ft"
    }, [_vm._v(_vm._s(item.initiatorName) + "提交的" + _vm._s(item.itemName))]), _vm._v(" "), _c('div', {
      staticClass: "ov"
    }, [_vm._v(_vm._s(item.bizItemName))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$root.formatDate(item.initiateTime)))]), _vm._v(" "), _c('div', [(item.processProgress == 'AUDIT_WAIT') ? _c('div', {
      staticClass: "status",
      staticStyle: {
        "color": "#e6a23c"
      }
    }, [_vm._v("\n                                        办理中")]) : _vm._e(), _vm._v(" "), (item.processProgress == 'AUDIT_OK') ? _c('div', {
      staticClass: "status",
      staticStyle: {
        "color": "green"
      }
    }, [_vm._v("审核通过\n                                    ")]) : _vm._e(), _vm._v(" "), (item.processProgress == 'AUDIT_REJECTED') ? _c('div', {
      staticClass: "status",
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("\n                                        审核不通过")]) : _vm._e()])])
  }), _vm._v(" "), (_vm.pageCount2 == _vm.pageNo2 && _vm.msgList2.length > 5) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("下面没有数据啦\n                            ")]) : _vm._e()], 2) : _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("暂无消息")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "xm-message-box",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_c('i', {
    staticClass: "el-icon-s-claim",
    staticStyle: {
      "font-size": "18px",
      "position": "relative",
      "margin-right": "15px"
    },
    attrs: {
      "title": "我的待办"
    },
    on: {
      "click": function($event) {
        return _vm.toMsg(1)
      }
    }
  }, [(_vm.messageCount != 0) ? _c('abbr', [_vm._v(_vm._s(_vm.messageCount > 99 ? '99+' : _vm.messageCount))]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "cc-pg",
    staticStyle: {
      "font-size": "18px",
      "position": "relative",
      "margin-right": "4px"
    },
    attrs: {
      "title": "抄送我"
    },
    on: {
      "click": function($event) {
        return _vm.toMsg(2)
      }
    }
  }, [(_vm.messageCount2 != 0) ? _c('abbr', [_vm._v(_vm._s(_vm.messageCount2 > 99 ? '99+' : _vm.messageCount2))]) : _vm._e()])])]), _vm._v(" "), _c('el-dropdown', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link userinfo-inner"
  }, [_c('i', {
    staticClass: "el-icon-user-solid",
    staticStyle: {
      "font-size": "18px"
    }
  }), _vm._v(" " + _vm._s(_vm.realName)), _c('i', {
    staticClass: "el-icon-caret-bottom"
  })]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    nativeOn: {
      "click": function($event) {
        return _vm.changeUser.apply(null, arguments)
      }
    }
  }, [_vm._v("切换账号")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toLogout.apply(null, arguments)
      }
    }
  }, [_vm._v("退出登录")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('router-view', {
    key: _vm.key
  }), _vm._v(" "), _c('ModalLoginWidget', {
    ref: "modalLogin"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22e6c32a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/HomeView.vue
// module id = 1651
// module chunks = 471